export const ROUTE_PATHS = {
    ARTICLE: 'article',
    ARTICLE_DYNAMIC_PATH: 'article/:name',
    DEFAULT: '',
    GAME: 'game',
    LIVE_DEALER: 'casino/livedealer',
    LOBBY: 'casino',
    LOBBY_DYNAMIC_PATH: 'casino/:name',
    PAGE_SELECTOR: 'page-selector',
    PROMOTIONS: 'promotions',
    UNKNOWN: '**'
};